import React, { useEffect } from "react";

import mixPanelService from "common/services/mixPanel";
import configSelector from "common/store/selectors/configSelector";

export default function MixpanelHandler() {
  useEffect(() => {
    const mixpanel = getMixpanelConfig();

    let tokens = [];
    if (mixpanel.enable && mixpanel.tokens.length) {
      tokens = mixpanel.tokens;
    }

    const config = {
      biz_id: window.ROOT_CONFIG.biz.id,
      biz_name: window.ROOT_CONFIG.biz.name,
    };

    let handlers = mixPanelService.init(
      tokens,
      config,
      window.ROOT_CONFIG.biz.env
    );
    return () => mixPanelService.unsubscribe(handlers);
  }, []);

  return <></>;
}

function getMixpanelConfig() {
  let config = window.ROOT_CONFIG;
  return configSelector.getMixPanel({ config: config });
}
